import { f as n } from "./index771.mjs";
var o = n, a = Function.prototype, t = a.apply, p = a.call, e = typeof Reflect == "object" && Reflect.apply || (o ? p.bind(t) : function() {
  return p.apply(t, arguments);
});
export {
  e as f
};
